import type { AvailabilityState } from "../EnergyDataAvailability.types";

export function getAvailabilityState(
  percentages: Array<number | null>
): AvailabilityState {
  if (percentages.length === 0) return "no meters";

  const notnullPercentages = percentages.filter((value) => value !== null);

  if (
    notnullPercentages.length === 0 ||
    notnullPercentages.every((value) => value === 0)
  ) {
    return "empty";
  }

  if (notnullPercentages.every((value) => value === 100)) {
    return "complete";
  }

  return "incomplete";
}
